<template>
  <div>
    <div style="background-color:#FDD835" class="d-none">
      <v-img
          class="mx-auto"
          max-width="1600"
          max-height="450"
          src="https://con1.artatolstatic.com/image/original/33d119d6-eb1d-4ee0-a5ad-7d93f09d453d.jpg"
          lazy-src="https://con1.artatolstatic.com/image/300/33d119d6-eb1d-4ee0-a5ad-7d93f09d453d.jpg"
          position="bottom"
      ></v-img>
    </div>
    <div class="d-none d-sm-block">
      <v-img
          max-height="450"
          contain
          class="mx-auto"
          :lazy-src="`https://con1.artatolstatic.com/cf/f_webp,s_300x300,c_0,q_40/${this.$vuetify.theme.dark ? heroImage.dark : heroImage.light}`"
          :src="`https://con1.artatolstatic.com/cf/f_png,s_3000x2000,c_0,q_80/${this.$vuetify.theme.dark ? heroImage.dark : heroImage.light}.png`"
          position="bottom"
      ></v-img>
    </div>

    <div class="text-center font-weight-black px-5 mt-5 mt-sm-0">
      <span class="text-h3" v-html="$t('home.title')">
      </span>
    </div>

  </div>
</template>

<script>
export default {
	name: "Home",
	data() {
	  return {
      heroImage: {
        dark: '83fd3fba-aa8b-4a81-b92e-779fd233c772', // c07bdd93-f7a4-4840-80ed-fa24428f7d7d, c922e712-4fb2-48ce-b397-947b6b6fa3ab
        light: 'da877efc-b9df-46e0-96f8-f12426e23f99', // e4748ebe-7aba-4997-bc6c-f9636cf3f9bc, 9c3be34a-4f5f-49c1-852e-0898c8b54df7
      }
    }
  },
}
</script>
